import { TConfig, TConfigInput } from '@@/auto/interfaces';

import { AUTO_DISCOUNTS } from '../../autoDiscounts';

function ToggleOHConfig(): DeepPartial<TConfigInput> {
  return {
    autoDiscounts: [
      AUTO_DISCOUNTS.distantStudent,
      AUTO_DISCOUNTS.goodStudent,
      AUTO_DISCOUNTS.homeowner,
      AUTO_DISCOUNTS.multiPolicy,
      AUTO_DISCOUNTS.matureDriver60,
      AUTO_DISCOUNTS.multiCar,
      AUTO_DISCOUNTS.safeDriving,
      AUTO_DISCOUNTS.teenDriver,
    ],
    visibleCoverages: (visibleCoverages: TConfig['visibleCoverages']) => {
      return {
        ...visibleCoverages,
        vehicleCoverages: [
          ...visibleCoverages.vehicleCoverages.filter(
            ({ key }) =>
              !['uninsured_motorist_property_damage_limit'].includes(key)
          ),
          {
            label: 'Uninsured Motorist Property Damage',
            key: 'uninsured_motorist_property_damage_limit',
          },
        ],
      };
    },
    initialCoverageValues: (
      initialCoverageValues: TConfig['initialCoverageValues']
    ) => ({
      ...initialCoverageValues,
      gap: 'false',
      temporary_ride: 'null',
      side_hustle: 'false',
      uninsured_motorist_property_damage_limit: '0',
    }),
  };
}
export default ToggleOHConfig;
